import React from 'react';
import Translation from '../../../../translation/translation';

function EditLabel() {
    return (
        <Translation
            translationKey="catalog-statusbar-mobile-edit-size-label"
            className="statusbar-mobile-current-status__size-label"
            tagName="span"
        />
    );
}

export { EditLabel };